import { html, View } from 'rune-ts';
import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';
import { classes } from '@services/MarppleShop/shared/util';
import klass from './BadgeRealtimeView.module.scss';
import { RankView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/RankView.ts';
import { IconView } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/IconView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { CardProductError } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductView.ts';

type TProps =
  | {
      size: 'Large (Xlarge~Large)';
      ranking?: number;
      ordered_at: string;
      currentTime: string;
    }
  | {
      size: 'Medium (Medium~Small)';
      ranking?: number;
      ordered_at: string;
      currentTime: string;
    };

export type TBadgeRealtimeWithoutSize = {
  ranking?: number;
  ordered_at: string;
  currentTime: string;
};

export class BadgeRealtimeView extends View {
  protected override template(props: TProps) {
    if (props.size === 'Large (Xlarge~Large)') {
      const { ordered_at, ranking, currentTime } = props;

      const hours = differenceInHours(new Date(currentTime), new Date(ordered_at));

      const minutes = differenceInMinutes(new Date(currentTime), new Date(ordered_at));

      const seconds = differenceInSeconds(new Date(currentTime), new Date(ordered_at));

      let displayTime;
      if (hours >= 1) {
        displayTime = ET('card_product::badge_main::just_sold_hours', { hours });
      } else if (minutes >= 1) {
        displayTime = ET('card_product::badge_main::just_sold_minutes', { minutes });
      } else {
        displayTime = ET('card_product::badge_main::just_sold_seconds', { seconds });
      }

      return html`<span class="${classes(klass.badge_main, klass.size_large)}">
        ${ranking ? new RankView({ size: 'Large (Xlarge~Large)', ranking }) : null}

        <span class="${classes(klass.badge, klass.size_large, klass.type_just_sold)}">
          <span class="${classes(klass.icon, klass.size_large)}">${new IconView({ type: 'Clock' })}</span>

          <span class="${classes(klass.text, klass.size_large)}">
            <span class="${font('14_bold')}"> ${displayTime} </span>

            <span class="${font('14_medium')}">${ET('card_product::badge_main::just_sold_ago')}</span>
          </span>
        </span>
      </span>`;
    } else if (props.size === 'Medium (Medium~Small)') {
      const { ordered_at, ranking, currentTime } = props;

      const hours = differenceInHours(new Date(currentTime), new Date(ordered_at));

      const minutes = differenceInMinutes(new Date(currentTime), new Date(ordered_at));

      const seconds = differenceInSeconds(new Date(currentTime), new Date(ordered_at));

      let displayTime;
      if (hours >= 1) {
        displayTime = ET('card_product::badge_main::just_sold_hours', { hours });
      } else if (minutes >= 1) {
        displayTime = ET('card_product::badge_main::just_sold_minutes', { minutes });
      } else {
        displayTime = ET('card_product::badge_main::just_sold_seconds', { seconds });
      }

      return html`<span class="${classes(klass.badge_main, klass.size_medium)}">
        ${ranking ? new RankView({ size: 'Medium (Medium~Small)', ranking }) : null}

        <span class="${classes(klass.badge, klass.size_medium, klass.type_just_sold)}">
          <span class="${classes(klass.icon, klass.size_medium)}">${new IconView({ type: 'Clock' })}</span>

          <span class="${classes(klass.text, klass.size_medium)}">
            <span class="${classes(font('11_bold'), klass.count)}">${displayTime}</span>

            <span class="${classes(font('11_regular'), klass.count)}"
              >${ET('card_product::badge_main::just_sold_ago')}</span
            >
          </span>
        </span>
      </span>`;
    } else {
      throw new CardProductError();
    }
  }
}
